import type { FormDetails } from '@cognitoforms/types/server-types/services/forms/form-details';
import type { LookupReferences } from '@cognitoforms/types/server-types/services/forms/lookup-references';
import { serviceRequest } from './service-request';

export function getFormDetails(formId: string): Promise<FormDetails> {
	return serviceRequest('svc/form-details/model', null, { method: 'GET', query: { formId } });
}

export function exportFormDetails(formIds) {
	return serviceRequest('svc/form-details/download', { formIds }, { method: 'POST' });
}

export function getReferences(formId: string, onlyReferencedBy: boolean = false): Promise<LookupReferences> {
	return serviceRequest('svc/form-details/references', null, { method: 'GET', query: { formId, onlyReferencedBy } });
}